import { PreloadedState, combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Account from './auth/register/reducer';
import Login from './auth/login/reducer';
import Forget from './auth/forgetpwd/reducer';
import Roles from './auth/roles/reducer';

// Administration
import Portfolios from './portfolio/reducer';
import FileData from './files/reducers';

// Offer search
// > this could be search, but maybe portoflios will have simmilar functionality
import Offers from './offers/reducer';

import Tariffs from './tariff/reducers';

import Options from './option/reducers';

import Hardware from './hardware/reducers';
import Report from './report/reducers';

// calculator config
import Calculator from './calculator/reducers';

// api
import ApiStatus from './api/reducers';

// notifications
import Notifications from './notifications/reducers';

// maintenance status
import Maintenance from './maintenance/reducers';

// Price List
import PriceList from './price_list/reducers';

import Approval from '../reducers/reducerApproval';

const rootReducer = combineReducers({
	Layout,
	Account,
	Login,
	Forget,
	Roles,
	Portfolios,
	Offers,
	Tariffs,
	Options,
	Hardware,
	FileData,
	Report,
	Calculator,
	ApiStatus,
	Notifications,
	Maintenance,
	PriceList,
	Approval
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
	return configureStore({
		reducer: rootReducer,
		preloadedState
	});
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
